import { render } from "./ButtonChatGPT.vue?vue&type=template&id=1f1b8601"
import script from "./ButtonChatGPT.vue?vue&type=script&lang=js"
export * from "./ButtonChatGPT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__